import React from 'react';
import { Row, Col } from 'react-bootstrap';
import QuestionGroup from "./QuestionGroup";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import * as FormActionCreator from "../../../redux/creators/form";
import { translate } from '../../base/Translation';

class QuestionGroups extends React.Component {

	componentDidMount() {
		this.shouldUpdate = false;
	}

	addGroup() {
		this.shouldUpdate = true;

		this.props.addGroup({
			id: -Math.random(),
			name: "",
			note: "",
			weight: 0,
			questions: []
		}, this.props.section);
	}

	render() {

		this.shouldUpdate = false;

		let groups = this.props.groups.map(function (group) {
			return (
				<QuestionGroup
					key={group.id}
					group={group}
					section={this.props.section}
					updateGroup={this.props.updateGroup}
					/>
			)
		}.bind(this));

		return (
			<Row>
				<Col lg={12}>
					{groups}
				</Col>
				<Col lg={12}>
					<button className="btn btn-primary btn-sm" onClick={this.addGroup.bind(this)}>{translate("Pridať skupinu")}</button>
				</Col>
			</Row>
		)
	}
}


function matchDispatchToProps(dispatch) {
	return bindActionCreators({ addGroup: FormActionCreator.addGroupAction,updateGroup: FormActionCreator.updateGroupAction }, dispatch);
}

export default connect(state => ({ form: state.form }), matchDispatchToProps)(QuestionGroups);
//export default QuestionGroups;


// WEBPACK FOOTER //
// ./src/modules/form/edit/QuestionGroups.js